export default {
  title: 'Rechnung anfordern',
  form: {
    is_receipt_required: {
      label: 'Rechnung via Email erhalten',
    },
    company_name: {
      placeholder: 'Unternehmen (Optional)',
    },
    first_name: {
      placeholder: 'Vornamen',
    },
    last_name: {
      placeholder: 'Nachname',
    },
    address: {
      placeholder: 'Strasse + Nummer',
    },
    zip_code: {
      placeholder: 'PLZ',
    },
    city: {
      placeholder: 'Stadt',
    },
    tax_id: {
      placeholder: 'St-Nr./USt-IdNr. *',
    },
    email: {
      placeholder: 'Email',
    },
  },
};
